import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { Add } from '@mui/icons-material';
import { Stack, Button, Box } from '@mui/material';
import { FormSectionHeader, FormSectionHeaderProps } from 'components/shared/FormSectionHeader';

interface Props<Value extends string> extends FormSectionHeaderProps<Value> {
  isSectionDisabled?: boolean;
}

export const ContingenciesSection = <Value extends string>({ isSectionDisabled, ...headerProps }: Props<Value>) => {
  const { handleOpen } = useModal(ModalsKeys.AddContingencyDialog);

  return (
    <Stack gap="1rem">
      <FormSectionHeader {...headerProps} />

      <Box>
        <Button size="small" disabled={isSectionDisabled} startIcon={<Add />} onClick={handleOpen}>
          Add Contingency
        </Button>
      </Box>
    </Stack>
  );
};
